import React from 'react';
import ReactDOMClient from 'react-dom/client';
const App = React.lazy(() => import('~/App'));

// Følgende er for å unngå 'unsafe-eval' CSP-feil
import { z } from "zod";
z.config({ jitless: true })

const element = document.getElementById('root');
if (element) {
    ReactDOMClient.createRoot(element).render(<App />);
}
